import getApiBaseUrl from '@/utils/getBaseUrl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface Payload {
  emailAddress: string;
  emailAddress2?: string;
  firstName: string;
  lastName?: string;
  coOwnerFirstName?: string;
  coOwnerLastName?: string;
  addressLine1?: string;
  addressLine2?: string;
  phoneNumber?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

export default function useBulkAddClients() {
  const queryClient = useQueryClient();

  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload[]) => {
      const response = await fetch(`${getApiBaseUrl()}/api/v1/clients/bulk`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to creat client: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['CLIENTS'] });
    },
  });
}
